import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import InstrumentService from './instrument-service';
import axios from 'axios';
import { useToast } from '../../../components/Toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FileUpload } from 'primereact/fileupload';
import BreadcrumbComponent from '../../../components/Breadcrumb';

const InstrumentUploadPreview = () => {
  const [clientState, setClientState] = useState<any>(null);
  const [excelData, setExcelData] = useState<any[]>([]);
  const { showToast } = useToast();
  const navigate = useNavigate();



  useEffect(() => {
    const fetchClientState = async () => {
      try {
        const clientStateItem = await InstrumentService.getClientState();
        setClientState(clientStateItem);
      } catch (error) {
        clientState.error.detail = error;
        showToast(clientState.error);
      }

    };

    fetchClientState();
  }, []);


  const excelDateToJSDate = (serial: any) => {
    if (serial === undefined || serial === null || serial === "") return null;
    if (typeof serial === "number") {
      return new Date(Date.UTC(1899, 11, 30) + serial * 86400000);
    }
    const parsed = new Date(serial);
    return isNaN(parsed.getTime()) ? null : parsed;
  };

  const formatDate = (value: any) => {
    const date = new Date(value);
    return isNaN(date.getTime())
      ? ''
      : date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', }); // e.g., 16/04/2025
  };
  // const handleFileUpload = (e: any) => {
  //   const file = e.target.files[0];
  //   const reader = new FileReader();

  //   reader.onload = (evt) => {
  //     const bstr = evt.target?.result;
  //     const workbook = XLSX.read(bstr, { type: 'binary' });
  //     const sheetName = workbook.SheetNames[0];
  //     const sheet = workbook.Sheets[sheetName];
  //     const data = XLSX.utils.sheet_to_json(sheet);

  //     const currentDate = new Date().toLocaleString("en-US", { timeZone: clientState.timeZone });
  //     const now = new Date(currentDate);

  //     const safeToString = (v: any) => v !== undefined && v !== null ? v.toString() : null;

  //     const cleanStr = (v: any) => (v ?? '').toString().trim() || null;
  //     const cleanUpper = (v: any) => (v == null ? '' : v.toString().trim().toUpperCase());
  //     const excelDateToJSDate = (serial: any) => {
  //       if (serial === undefined || serial === null || serial === '') return null;
  //       if (typeof serial === 'number') return new Date(Date.UTC(1899, 11, 30) + serial * 86400000);
  //       const parsed = new Date(serial);
  //       return isNaN(parsed.getTime()) ? null : parsed;
  //     };


  //     const transformedData = data.map((row: any, index: number) => ({
  //       insertBy: clientState.userId,
  //       insertDate: now,
  //       modifiedBy: clientState.userId,
  //       modifiedDate: now,
  //       facilityCode: clientState.facilityCode,
  //       entity: cleanStr(row["Entity"] ?? row.entity),
  //       snNo: cleanUpper(row["Serial Number"] ?? row.sn_no),
  //       itemCode: safeToString(row["Item Code"] ?? row.item_code),
  //       itemDesc: safeToString(row["Item Description"] ?? row.item_desc),
  //       manufacturerName: safeToString(row["Manufacturer Name"] ?? row.manufacturer_name),
  //       lastPmDate: excelDateToJSDate(row["Last PM Date"]) || null,
  //       nextPmDate: excelDateToJSDate(row["Next PM Date"]) || null,
  //       installDate: excelDateToJSDate(row["Installation Date"]) || null,
  //       warrantyEndDate: excelDateToJSDate(row["Warranty End Date"]) || '',
  //       installationLocation: safeToString(row["Installation Location"] ?? row.installation_location),
  //       state: safeToString(row["Region"] ?? row.state),
  //       // equipType: safeToString(row["Equipment Type"] ?? row.equip_type),
  //       equipType: (
  //         !row["Equipment Type"] ||
  //         row["Equipment Type"] === 'NULL' ||
  //         row["Equipment Type"] === null ||
  //         row["Equipment Type"] === undefined
  //       )
  //         ? ' '
  //         // : safeToString(row["Equipment Type"] ?? row.equip_type).toUpperCase(),
  //         : safeToString(row["Equipment Type"] ?? row.equip_type),
  //     }));



  //     setExcelData(transformedData);
  //   };
  //   reader.readAsBinaryString(file);
  // };

  const handleFileUpload = (e: any) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = evt.target?.result as string | ArrayBuffer | null;
      if (!bstr) return;

      const workbook = XLSX.read(bstr, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // 1) Baca sheet dengan option yang betul
      const raw = XLSX.utils.sheet_to_json(sheet, {
        defval: null,      // kosong jadi null, bukan undefined atau ''
        blankrows: false,  // jangan ambil row kosong
        header: 1          // baca sebagai array-of-arrays dulu untuk detect header
      }) as any[][];

      if (!raw.length) {
        setExcelData([]);
        return;
      }

      // 2) Extract header dan rows
      const [headerRow, ...rows] = raw;

      // Helper: cari index kolum ikut nama
      const col = (name: string) => headerRow.findIndex((h: any) => (h ?? '').toString().trim().toLowerCase() === name.toLowerCase());

      // Index penting (edit kalau header berubah)
      const cEntity = col('Entity');
      const cSerialNumber = col('Serial Number');
      const cItemCode = col('Item Code');
      const cItemDesc = col('Item Description');
      const cManufacturerName = col('Manufacturer Name');
      const cLastPmDate = col('Last PM Date');
      const cNextPmDate = col('Next PM Date');
      const cInstallationDate = col('Installation Date');
      const cWarrantyEndDate = col('Warranty End Date');
      const cInstallationLocation = col('Installation Location');
      const cRegion = col('Region');
      const cEquipType = col('Equipment Type');

      // 3) Utility
      const now = new Date(new Date().toLocaleString("en-US", { timeZone: clientState?.timeZone || 'Asia/Kuala_Lumpur' }));
      const safeToString = (v: any) => v == null ? null : v.toString();
      const cleanStr = (v: any) => (v ?? '').toString().trim() || null;
      const cleanUpper = (v: any) => (v == null ? '' : v.toString().trim().toUpperCase());
      const excelDateToJSDate = (serial: any) => {
        if (serial === undefined || serial === null || serial === '') return null;
        if (typeof serial === 'number') return new Date(Date.UTC(1899, 11, 30) + serial * 86400000);
        const parsed = new Date(serial);
        return isNaN(parsed.getTime()) ? null : parsed;
      };

      // 4) Filter row kosong (wajib ada sekurang-kurangnya salah satu kunci)
      const hasContent = (r: any[]) => {
        const keys = [cSerialNumber, cItemCode, cItemDesc, cManufacturerName, cInstallationLocation, cRegion, cEntity, cEquipType]
          .filter(i => i >= 0);
        return keys.some(i => {
          const v = (r[i] ?? '').toString().trim();
          return v !== '';
        });
      };

      const filteredRows = rows.filter(hasContent);

      // 5) Transform ke shape yang kau nak
      const transformedData = filteredRows.map((r: any[]) => ({
        insertBy: clientState?.fullName,
        insertDate: now,
        modifiedBy: clientState?.fullName,
        modifiedDate: now,
        facilityCode: clientState?.facilityCode,

        entity: cleanStr(r[cEntity]),
        snNo: cleanUpper(r[cSerialNumber]),
        itemCode: cleanUpper(r[cItemCode]),
        itemDesc: safeToString(r[cItemDesc]),
        manufacturerName: safeToString(r[cManufacturerName]),

        lastPmDate: excelDateToJSDate(r[cLastPmDate]) || null,
        nextPmDate: excelDateToJSDate(r[cNextPmDate]) || null,
        installDate: excelDateToJSDate(r[cInstallationDate]) || null,
        warrantyEndDate: excelDateToJSDate(r[cWarrantyEndDate]) || null,

        installationLocation: safeToString(r[cInstallationLocation]),
        state: safeToString(r[cRegion]),

        // Kalau kosong/NULL, biar null je — jangan letak ' ' sebab nampak macam ada data
        equipType: cleanStr(r[cEquipType]),

        status: 'Active'
      }));

      setExcelData(transformedData);
    };

    reader.readAsBinaryString(file);
  };


  const handleSaveToDb = async () => {
    try {



      // console.log("Data to be saved:", excelData);
      await InstrumentService.uploadExcelData(excelData);
      showToast(clientState.success);
      navigate("/machine/instrument");
    } catch (err) {
      showToast(clientState.error);
      console.error(err);
    }
  };

  const handleBack = () => {
    navigate(`/machine/instrument`);
  }

  const handleDownloadTemplate = () => {
    const link = document.createElement('a');
    link.href = '/template.xlsx';
    link.setAttribute('download', 'Template-instrument.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card-title">
          <h5>Instrument List</h5>
          <BreadcrumbComponent />
        </div>

        <div className="card">
          {/* ✅ Upload Button - Top Right */}
          <div className="flex justify-content-end mb-3">
            <div className="p-inputgroup">
              <label htmlFor="uploadExcel">
                <Button
                  icon="pi pi-download"
                  label="Template Excel"
                  className="p-button-secondary"
                  style={{ marginRight: '.5em' }}
                  onClick={() => handleDownloadTemplate()}
                />
              </label>

              <label htmlFor="uploadExcel">
                <Button
                  icon="pi pi-upload"
                  label="Upload Excel"
                  className="p-button-primary"
                  type="button"
                  style={{ marginRight: '.5em' }}
                  onClick={() => document.getElementById('uploadExcel')?.click()}
                />
              </label>
              <input
                type="file"
                id="uploadExcel"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
            </div>
          </div>





          {/* ✅ Data Table & Save Button */}
          {excelData.length > 0 && (
            <>
              <DataTable
                value={excelData}
                showGridlines
                scrollable
                scrollHeight="400px"
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 20]}
                responsiveLayout="scroll"
              >
                <Column
                  header="No."
                  style={{ width: '5%' }}
                  body={(_, { rowIndex }) => rowIndex + 1}
                />
                <Column field="snNo" header="Serial No" />
                <Column field="itemCode" header="Item Code" />
                <Column field="itemDesc" header="Item Description" />
                <Column field="manufacturerName" header="Manufacturer Name" />
                <Column field="lastPmDate" header="Last PM Date" body={(rowData) => rowData?.lastPmDate ? new Date(rowData.lastPmDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', }) : ''} />
                <Column field="nextPmDate" header="Next PM Date" body={(rowData) => rowData?.nextPmDate ? new Date(rowData.nextPmDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', }) : ''} />
                <Column field="installDate" header="Install Date" body={(rowData) => rowData?.installDate ? new Date(rowData.installDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', }) : ''} />
                <Column field="warrantyEndDate" header="Warranty End Date" body={(rowData) => rowData?.warrantyEndDate ? new Date(rowData.warrantyEndDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', }) : ''} />
                <Column field="equipType" header="Equipment Type" />
                <Column field="insertDate" header="Register Date" body={(rowData) => formatDate(rowData.insertDate)} />
                <Column field="installationLocation" header="Installation Location" />
                <Column field="state" header="Region" />
              </DataTable>

              {/* ✅ Save & Back Buttons - Bottom Right */}
              <div className="flex justify-content-end mt-3 gap-2">
                <Button
                  label="Save to Database"
                  icon="pi pi-save"
                  className="p-button-success"
                  onClick={handleSaveToDb}
                />
                <Button
                  label="Back"
                  icon="pi pi-reply"
                  className="p-button-secondary"
                  onClick={handleBack}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );

};

export default InstrumentUploadPreview;
